module.exports = __webpack_public_path__ + "static/media/BbBv2_20191010_133001277426023.43ec0a2b.jpg";